"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var EPG_1 = require("stremio/common/EPG");
var useGuideViewport_1 = __importDefault(require("./useGuideViewport"));
var Header_1 = __importDefault(require("./Header"));
var ChannelColumn_1 = __importDefault(require("./ChannelColumn"));
var Row_1 = __importDefault(require("./Row"));
var Skeleton_1 = __importDefault(require("./Skeleton"));
var Guide_less_1 = __importDefault(require("./Guide.less"));
var CHANNEL_COLUMN_WIDTH = 130;
var ROW_HEIGHT = 56;
var ROW_STRIDE = 60;
var OVERSCAN_ROWS = 3;
var TIME_OVERSCAN_PX = 300;
var LOAD_MORE_THRESHOLD_PX = 400;
var SKELETON_ROWS = 20;
var EMPTY_PROGRAMS = [];
var currentProgramIndex = function (programs, now) {
    return programs.findIndex(function (program) { return (0, EPG_1.programStartMs)(program) <= now && now < (0, EPG_1.programEndMs)(program); });
};
var Guide = function (_a) {
    var _b;
    var channels = _a.channels, programs = _a.programs, loading = _a.loading, selectedDate = _a.selectedDate, today = _a.today, dayWindow = _a.dayWindow, error = _a.error, onRetry = _a.onRetry, hasNextPage = _a.hasNextPage, loadNextPage = _a.loadNextPage, now = _a.now, onProgramSelect = _a.onProgramSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var todayDate = (0, react_1.useMemo)(function () { var _a; return (_a = (0, EPG_1.parseEpgDate)(today)) !== null && _a !== void 0 ? _a : new Date(); }, [today]);
    var effectiveDay = (0, react_1.useMemo)(function () { var _a; return (_a = (0, EPG_1.parseEpgDate)(selectedDate)) !== null && _a !== void 0 ? _a : todayDate; }, [selectedDate, todayDate]);
    var _c = (0, react_1.useMemo)(function () {
        return dayWindow ?
            { start: Date.parse(dayWindow.start), end: Date.parse(dayWindow.end) }
            :
                (0, EPG_1.epgDayWindow)(effectiveDay);
    }, [dayWindow, effectiveDay]), dayStart = _c.start, dayEnd = _c.end;
    var _d = (0, useGuideViewport_1.default)(dayStart, dayEnd, now), viewportRef = _d.viewportRef, headerRef = _d.headerRef, channelColumnRef = _d.channelColumnRef, viewport = _d.viewport, pixelsPerHour = _d.pixelsPerHour, zoom = _d.zoom, scrollToTime = _d.scrollToTime;
    var totalGridWidth = ((dayEnd - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour;
    var tickMinutes = (_b = EPG_1.EPG_TICK_MINUTES.find(function (minutes) { return minutes * pixelsPerHour / 60 >= viewport.minTickWidth; })) !== null && _b !== void 0 ? _b : EPG_1.EPG_TICK_MINUTES[EPG_1.EPG_TICK_MINUTES.length - 1];
    var tickSize = tickMinutes * 60000;
    var tickWidth = tickSize * pixelsPerHour / EPG_1.HOUR_IN_MS;
    var firstTick = Math.max(0, Math.floor((viewport.left - TIME_OVERSCAN_PX) / tickWidth));
    var lastTick = Math.min(Math.ceil((dayEnd - dayStart) / tickSize), Math.ceil((viewport.left + viewport.width + TIME_OVERSCAN_PX) / tickWidth));
    var visibleStart = dayStart + firstTick * tickSize;
    var visibleEnd = dayStart + lastTick * tickSize;
    var initialLoading = loading && channels.length === 0;
    var firstRow = Math.max(0, Math.floor(viewport.top / ROW_STRIDE) - OVERSCAN_ROWS);
    var lastRow = Math.min(channels.length, Math.ceil((viewport.top + viewport.height) / ROW_STRIDE) + OVERSCAN_ROWS);
    var visibleChannels = channels.slice(firstRow, lastRow);
    var rowPadding = { paddingTop: firstRow * ROW_STRIDE, paddingBottom: Math.max(0, channels.length - lastRow) * ROW_STRIDE };
    var nearEnd = viewport.height > 0 && viewport.top + viewport.height >= channels.length * ROW_STRIDE - LOAD_MORE_THRESHOLD_PX;
    (0, react_1.useEffect)(function () {
        if (hasNextPage && !loading && nearEnd) {
            loadNextPage();
        }
    }, [hasNextPage, loading, nearEnd, loadNextPage]);
    var errorContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: Guide_less_1.default['error-message'] }, error),
        react_1.default.createElement(components_1.Button, { className: Guide_less_1.default['error-retry'], onClick: onRetry }, t('TRY_AGAIN'))));
    return (react_1.default.createElement("div", { className: Guide_less_1.default['guide'] },
        react_1.default.createElement(Header_1.default, { headerRef: headerRef, channelColumnWidth: CHANNEL_COLUMN_WIDTH, dayStart: dayStart, dayEnd: dayEnd, pixelsPerHour: pixelsPerHour, viewport: viewport, ticks: { first: firstTick, last: lastTick, size: tickSize, width: tickWidth }, totalGridWidth: totalGridWidth, onZoom: zoom, onScrollToTime: scrollToTime }),
        react_1.default.createElement("div", { className: Guide_less_1.default['body'] },
            react_1.default.createElement(ChannelColumn_1.default, { innerRef: channelColumnRef, width: CHANNEL_COLUMN_WIDTH, rowHeight: ROW_HEIGHT, channels: visibleChannels, skeletonRows: initialLoading ? SKELETON_ROWS : 0, style: initialLoading ? undefined : rowPadding }),
            react_1.default.createElement("div", { ref: viewportRef, className: Guide_less_1.default['viewport'], "aria-busy": loading, tabIndex: 0 },
                react_1.default.createElement("div", { className: Guide_less_1.default['grid'], style: { width: totalGridWidth } },
                    now >= dayStart && now < dayEnd ?
                        react_1.default.createElement("div", { className: Guide_less_1.default['now-line'], style: { left: ((now - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour } })
                        :
                            null,
                    initialLoading ?
                        react_1.default.createElement(Skeleton_1.default, { rows: SKELETON_ROWS, rowHeight: ROW_HEIGHT, width: totalGridWidth, pixelsPerHour: pixelsPerHour })
                        :
                            react_1.default.createElement("div", { className: Guide_less_1.default['rows'], style: rowPadding }, visibleChannels.map(function (channel) {
                                var _a;
                                var channelPrograms = (_a = programs[channel.id]) !== null && _a !== void 0 ? _a : EMPTY_PROGRAMS;
                                return (react_1.default.createElement(Row_1.default, { key: channel.id, channel: channel, programs: channelPrograms, currentProgramIndex: currentProgramIndex(channelPrograms, now), dayStart: dayStart, dayEnd: dayEnd, visibleStart: visibleStart, visibleEnd: visibleEnd, pixelsPerHour: pixelsPerHour, onProgramClick: onProgramSelect }));
                            })),
                    loading && channels.length > 0 ?
                        react_1.default.createElement("div", { className: Guide_less_1.default['loading-more'], role: 'status' }, t('STREAM_LOADING'))
                        :
                            null,
                    error !== null && channels.length > 0 ?
                        react_1.default.createElement("div", { className: Guide_less_1.default['next-page-error'] }, errorContent)
                        :
                            null)),
            !initialLoading && channels.length === 0 && error === null ?
                react_1.default.createElement("div", { className: Guide_less_1.default['empty'], role: 'status' }, t('NO_STREAM'))
                :
                    null,
            error !== null && channels.length === 0 ?
                react_1.default.createElement("div", { className: Guide_less_1.default['error'] }, errorContent)
                :
                    null)));
};
exports.default = Guide;
